import { makeStyles, Theme } from '@material-ui/core/styles';

const styles = makeStyles(({ variables, breakpoints }: Theme) => ({
  insideDrawer: {
    width: '330px',
    flexShrink: 0,
  },
  insideDrawerPaper: {
    ['@media (display-mode: standalone)']: {
      marginTop: '45px',
      ['&.isAndroid']: {
        marginTop: '0px !important',
      },
    },
    width: '360px',
    top: '57px',
    paddingBottom: variables?.spacingH,
    [breakpoints.down('sm')]: {
      width: '90%',
    },
  },

  insideDrawerPaperFull: {
    ['@media (display-mode: standalone)']: {
      paddingTop: '40px',
      ['&.isAndroid']: {
        paddingTop: '0px !important',
      },
    },
    width: '352px',
    overflowX: 'hidden',
    ['@media only screen and (max-width:1028px)']: {
      width: '288px',
    },
  },
  notificationDrawerCTA: {
    padding: variables?.spacingD,
    display: 'flex',
    alignItems: 'center',
    '& > svg': {
      marginRight: variables?.spacingB,
    },
  },
}));

export default styles;
